// extracted by mini-css-extract-plugin
var _1 = "zEBJQ62h0fzO5kqBOJ_I";
var _2 = "ja62nrBdGEUpwxJPhgxo";
var _3 = "XU_ZyAgnIsUAhFB7EdUl";
var _4 = "MXDO0c1DTj5v6Ged4MzQ";
var _5 = "VH9bl_vhzV6kiaLjnU_w";
export { _1 as "button", _2 as "controls", _3 as "input", _4 as "uploadGuideTip", _5 as "wrapper" }
